/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header, Label, Segment } from '@mairistem/composants';

import { COLORS } from '@/constants';
// eslint-disable-next-line import/no-extraneous-dependencies
import type { Property } from 'csstype';

interface Props {
  title: string;
  width?: Property.Width;
  height?: Property.Height;
  children: React.ReactNode;
  style?: React.CSSProperties;
  'data-testid'?: string;
}

const Section = (props: Props) => {
  const {
    title,
    width = '100%',
    height = '100%',
    children,
    style,
    'data-testid': dataTestId,
  } = props;

  return (
    <Segment
      raised
      data-testid={dataTestId}
      style={{
        width,
        minHeight: height,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        border: `solid 1px ${COLORS.SectionBorderColor}`,
        ...style,
      }}
    >
      <Label
        attached="top"
        style={{
          backgroundColor: COLORS.Background,
          borderRadius: '16px 16px 0 0',
        }}
        content={
          <Header
            as="h4"
            content={title}
            textAlign="center"
            style={{ color: 'white' }}
          />
        }
      />
      {children}
    </Segment>
  );
};

export default Section;
